import * as App from '../../app';
import { DIV } from '../../lib/dom';
export function settingsBtn(game, settingsModal) {
    return new DIV({
        className: 'SettingsBtn',
        onClick: function () {
            if (game.isTimerEffect()) {
                App.sounds.disabled();
                return;
            }
            App.sounds.clickButton();
            settingsModal.show();
        },
    });
}
